<script setup lang="ts" generic="T extends string">
import { computed } from 'vue'

interface FilterChipProps {
  value: T
  label: string
  type?: 'radio' | 'checkbox'
}

const props = withDefaults(defineProps<FilterChipProps>(), {
  type: 'radio',
})

// Single value for radio, array for checkbox
const model = defineModel<T | T[]>({ required: true })

const isChecked = computed(() => {
  if (Array.isArray(model.value)) {
    return (model.value as T[]).includes(props.value)
  }
  return model.value === props.value
})
</script>

<template>
  <label class="typo-sans-1 leading-none cursor-pointer select-none uppercase">
    <input
      v-model="model"
      :type="type"
      :value="value"
      class="peer sr-only"
    >
    <span
      class="px-2 py-1.5 motion-snug rounded block @hover:c-$negative-color peer-focus-visible:outline-2 peer-focus-visible:outline-current peer-focus-visible:outline-offset-2 peer-focus-visible:outline @hover:bg-$primary-color"
      :class="isChecked ? 'bg-$primary-color c-$negative-color' : 'c-$primary-color bg-$negative-color'"
    >
      {{ label }}
    </span>
  </label>
</template>
